import { Injectable } from '@angular/core';
import { IActiveCourses, ICourse } from '@interfaces/ICourse';
import { IAppState } from '@myStore/app.state';
import {
  ECoursesViewActions,
  GetActiveCoursesFailure,
  GetActiveCoursesRequest,
  GetActiveCoursesSuccess,
  GetCourseDetailFailure,
  GetCourseDetailRequest,
  GetCourseDetailSuccess,
  GetCoursesFailure,
  GetCoursesRequest,
  GetCoursesSuccess,
  GetInactiveCoursesFailure,
  GetInactiveCoursesSuccess,
} from '@myStore/courses-view/courses-view.actions';
import { UserInfoLoadingForTabs } from '@myStore/users/user.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CoursesViewService } from '@services/courses-view/courses-view.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class CoursesViewEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _coursesViewService: CoursesViewService
  ) {}

  $getCourses = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetCoursesRequest>(ECoursesViewActions.GetCoursesRequest),
        switchMap(action => {
          return this._coursesViewService.getCourses(action.qParams).pipe(
            map((courses: ICourse[]) => {
              this._store.dispatch(new GetCoursesSuccess(courses));
            }),
            catchError(err => {
              this._toastr.error(
                `При запросе курсов возникла ошибка (get)`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new GetCoursesFailure());
              return err.statusText;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getCourseDetail = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetCourseDetailRequest>(
          ECoursesViewActions.GetCourseDetailRequest
        ),
        map(action => action),
        switchMap(action => {
          return this._coursesViewService.getCourseDetail(action.id).pipe(
            map((course: ICourse) => {
              this._store.dispatch(new GetCourseDetailSuccess(course));
            }),
            catchError(err => {
              this._toastr.error(
                `При запросе курса возникла ошибка (get)`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new GetCourseDetailFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getActiveCourses = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetActiveCoursesRequest>(
          ECoursesViewActions.GetActiveCoursesRequest
        ),
        switchMap(action => {
          return this._coursesViewService.getActiveCourses(action.qParams).pipe(
            map((courses: IActiveCourses) => {
              this._store.dispatch(new GetActiveCoursesSuccess(courses));
              this._store.dispatch(new UserInfoLoadingForTabs(false));
            }),
            catchError(err => {
              this._toastr.error(
                `При получении активных курсов возникла ошибка (get)`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new GetActiveCoursesFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getInactiveCourses = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetActiveCoursesRequest>(
          ECoursesViewActions.GetInactiveCoursesRequest
        ),
        switchMap(() => {
          return this._coursesViewService.getInactiveCourses().pipe(
            map((courses: IActiveCourses) => {
              this._store.dispatch(new GetInactiveCoursesSuccess(courses));
            }),
            catchError(err => {
              this._toastr.error(
                `При запросе неактивных курсов возникла ошибка (get)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetInactiveCoursesFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
